/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 25/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 05/06/2026 | Lic. José Luis Aragón Cervantes  | Recuperación de preventas entre cajas
*      3       | 05/06/2026 | Lic. José Luis Aragón Cervantes  | Texto contextual para editar o recuperar
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import { apiRecuperarListaPreventas, apiParametrosCaja} from "../../settings/ApiConfig"
import { useRequest } from "../../context/System/RequestContext";
import { useLayout } from "../../context/System/LayoutContext";
import { useSesion } from "../../context/System/SesionContext"; 

import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import KeyIcon from "@mui/icons-material/LockOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineSharp";
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import SizeSoftXTablePaginadoFilter from "../leyout/SizeSoftXTablePaginadoFilter"

import { Modal, Box, MenuItem, Typography, InputAdornment } from "@mui/material";
import _ from 'lodash';

// Estilos para el modal con efecto suavizado de desplazamiento
const modalStyle = {
    position: 'fixed',
    top: '9%',
    right: '5%',
    width: '90vw',
    height: '71vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateX(100%)', // Inicialmente fuera de la pantalla
    transition: 'transform 0.5s ease-in-out',
    borderRadius: '9px',
};

export default function ModalRecuperarPreventas(props) {
    const { openModalRecuperarPreventas, handleCloseModalRecuperarPreventas, handleRecuperarPreventas, vendedor = "" } = props;
  const {parametrosCajaForm} = useSesion();

    const vendedorNombre = String(vendedor ?? "");

    const { GetRequest, PostRequest } = useRequest()
    const { handleOpenAlert } = useLayout();

    const [modalVisible, setModalVisible] = useState(false);
    const [internalOpen, setInternalOpen] = useState(false);
    
    const [folioSeleccionado, setFolioSeleccionado] = useState({});    
    const [listaVentas, setListaVentas] = useState([]);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const esPreventaOtraCaja = Boolean(
        folioSeleccionado?.pc &&
        parametrosCajaForm?.caja &&
        String(folioSeleccionado.pc).trim().toUpperCase() !== String(parametrosCajaForm.caja).trim().toUpperCase()
    );
    
    useEffect(() => {
        if (openModalRecuperarPreventas) {
            setInternalOpen(true);
            setTimeout(() => setModalVisible(true), 50);
            handleBuscarVentas();
        } else {
            setModalVisible(false);
            setTimeout(() => setInternalOpen(false), 500);
        }
    }, [openModalRecuperarPreventas]);

    const modalVisibleStyle = {
        transform: modalVisible ? 'translateX(0)' : 'translateX(100%)',
    };
    
    const handleBuscarVentas = async()=>{
        if(!vendedorNombre || vendedorNombre === "")
            return;

        let url = "";

        if (!vendedorNombre.trim()) return;
        url= apiRecuperarListaPreventas.replace("{vendedor}",vendedorNombre).replace("{pc}",parametrosCajaForm.caja.trim());
        //Rutina de petición para jalar registros a destino ya sea ventas o preventas
        const response = await GetRequest({
            url,
            loader:"Buscando registros en sistema..."
        });
       
        if (response.hasError)
        {
            handleOpenAlert(response.message);
            setTotalRegistros(0);
            setListaVentas([]);
            return;
        }    

        const preventas = (response?.result ?? []).map((preventa, index) => ({
            ...preventa,
            idrecuperacion: `${preventa.pc || ""}-${preventa.foliopreventa || 0}-${index}`,
        }));

        setTotalRegistros(preventas.length);
        setListaVentas(preventas);
    };

    const handleAccionarRecuperarPreventa=()=>{
        handleRecuperarPreventas(vendedorNombre, folioSeleccionado);
        handleCloseModalRecuperarPreventas();        
    };
    
    const handleChangeFolioSeleccionada = (x) =>{
        
        setFolioSeleccionado(x);
    };

    useEffect(()=>{
        handleBuscarVentas()
    },[vendedorNombre])

    return (
        <Modal
            open={internalOpen}
            onClose={handleCloseModalRecuperarPreventas}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
            closeAfterTransition
            onSubmit={handleAccionarRecuperarPreventa}
            >
            <Box sx={{ ...modalStyle, ...modalVisibleStyle }}>
                <Fragment>
                <div className="containerFirma">
                    <TextField autoComplete="off"
                        name="vendedor"
                        label="Vendedor:"
                        value={vendedorNombre} // Asegurar de que `vendedor` contenga el nombre y no el ID
                        sx={{ width: '240px' }}
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                                <PersonIcon />
                            </InputAdornment>
                            ),
                            readOnly: true, // Esto asegura que no sea editable
                        }}/>
                    </div>
                    <div className="containerPassword">
                        <SizeSoftXTablePaginadoFilter
                            columns={[
                                { title: "Caja" , field: "pc"},
                                { title: "Descripción", field: "descripcion" },
                                { title: "Medida", field: "medida" },
                                { title: "Cantidad", field: "cantidad" },
                                { title: "fecha/hora", field: "fecharegistro" },
                                { title: "Vendedor", field: "vendedorpreventa" },
                                { title: "Folio preventa", field: "foliopreventa" },
                                { title: "Tipo venta" , field: "tipoventa"},
                            ]}
                            data={listaVentas}
                            totalDeRegistros={totalRegistros}
                            id="idrecuperacion"
                            row={folioSeleccionado}
                            setRow={handleChangeFolioSeleccionada}
                            fontSize="small"
                            rowsPerPageSet = {50}
                            EspaciadorColumnas = {9}
                        />                    
                    </div>
                    <div className="containerSubmit">
                        <button type="submit" className="jalarRegistrosButton" onClick={handleAccionarRecuperarPreventa}>
                            {esPreventaOtraCaja ? "Recuperar preventa" : "Editar preventa"}
                        </button>
                    </div>
                </Fragment>
            </Box>
        </Modal>
    );
}
